import authServer from "@/services/auth.service";

export class ServerHandler {
  async getServerInfo() {
    const res = await authServer.getServerInfo();
    const data = res.data.data;

    return {
      buildDate: data.build_date,
      FAOAuth2Callback: data.fa_oauth2_callback,
      isCloud: data.is_cloud,
      onpremVersion: data.onprem_version,
      serverID: data.server_id,
      version: data.version,
    };
  }
}
